(function() {
    'use strict';

    var GestioneNoteCtrl = function(
        idPratica,
        message,
        noteBackoffice,
        $uibModalInstance
    ) {
        this.idPraticaModal = idPratica;
        this.operationMessageModal = message;
        this.noteBackofficeModal = noteBackoffice;
        this.patternText = /^[a-zA-Z0-9 \u00E0-\u00FC-\u002F-\u005C-\u002C\u002E\u003A\u003B\u002D\u005F\u0022\r\n']+$/i;

        this.ok = function () {
            $uibModalInstance.close(this.noteBackofficeModal);
        };

        this.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    GestioneNoteCtrl.$inject = [
        'idPratica',
        'message',
        'noteBackoffice',
        '$uibModalInstance'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .controller('MitomGestioneNoteController', GestioneNoteCtrl);
})();